import actions from './actions';
import authActions from '../auth/actions';
const initState = {
  reportType: 'projection-status-report',
  chooseReportComponentType: [],
  errorMessage: null,
  isError: null,
  monitoringTypeMenu: null,
  monitoringTypeMenuLoading: false,
  pageLoading: false,
  monitoringReportData: null,
  monitoringReportFilter: null,
  monitoringReportLoading: false,
  generatedReportTransactions: null,
  downloadReportLoading: false,
  merchantPagination: null
};

export default function monitoringReducer(state = initState, action) {
  switch (action.type) {
    case actions.SELECT_REPORT_TYPE:
      return {
        ...state,
        reportType: action.payload
      };
    case actions.RESET_FILTER_REPORTS:
      return {
        ...state,
        monitoringReportData: null,
        merchantPagination: null
      };

    case actions.CHOOSE_REPORT_COMPONENT_TYPE:
      return {
        ...state,
        chooseReportComponentType: action.payload
      };

    case actions.CLEAR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
        isError: false,
        generatedReportTransactions: null
      };

    case actions.FETCHING_MONITORING_MENU_DATA:
      return {
        ...state,
        monitoringTypeMenu: null,
        pageLoading: true,
        monitoringTypeMenuLoading: action.loading
      };

    case actions.FETCH_MONITORING_MENU_DATA_SUCCESS:
      return {
        ...state,
        monitoringTypeMenuLoading: action.loading,
        pageLoading: false,
        monitoringTypeMenu: action.result,
        isError: false
      };

    case actions.FETCH_MONITORING_MENU_DATA_FAILED:
      return {
        ...state,
        monitoringTypeMenuLoading: action.loading,
        pageLoading: action.loading,
        monitoringTypeMenu: action.result,
        isError: true
      };

    case actions.FILTERING_REPORT_TRANSACTIONS:
      return {
        ...state,
        pageLoading: true,
        monitoringReportLoading: true,
        monitoringReportData: null
      };

    case actions.FILTER_REPORT_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        monitoringReportLoading: action.loading,
        monitoringReportData: action.result,
        pageLoading: false,
        isError: false,
        monitoringReportFilter: action.filter,
        merchantPagination: action.merchantPagination
      };

    case actions.FILTER_REPORT_TRANSACTIONS_FAILED:
      return {
        ...state,
        isError: true,
        monitoringReportLoading: action.loading,
        pageLoading: action.loading,
        monitoringReportData: action.result
      };

    case actions.DOWNLOADING_REPORT_TRANSACTIONS:
      return {
        ...state,
        pageLoading: true,
        downloadReportLoading: true
      };

    case actions.DOWNLOAD_REPORT_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        downloadReportLoading: false,
        generatedReportTransactions: action.result,
        isError: false
      };

    case actions.DOWNLOAD_REPORT_TRANSACTIONS_FAILED:
      return {
        ...state,
        isError: true,
        downloadReportLoading: action.loading,
        pageLoading: action.loading,
        generatedReportTransactions: null
      };

    case authActions.LOGOUT:
      // reset all redux param values
      return initState;
    default:
      return state;
  }
}
